import React from 'react';

import Lottie from 'react-lottie';
import anim_table_loader from 'assets/images/animations/table_loader.json';

import 'assets/scss/components/loaders/tableLoader.scss';

export function TableLoader(props) { 
    const defaultOptions = {
        loop: true,
        autoplay: true, 
        animationData: anim_table_loader,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    return (
        <div className={"component-tableLoader d-flex justify-content-center align-items-center"}>
            <Lottie options={defaultOptions}
                height={250}
                width={250}
                isClickToPauseDisabled
            />
        </div>
    );
}